export const LogoMark = ({ className = "w-10 h-10" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <rect x="28.5" y="34" width="7" height="26" rx="2" fill="#1B1A2E" />
    <path d="M8 60c3-6 5-6 7 0M18 60c2-5 4-5 6 0M40 60c2-5 4-5 6 0M49 60c3-6 5-6 7 0" stroke="#19B37A" strokeWidth="3.5" fill="none" strokeLinecap="round" />
    <g transform="rotate(-6 32 22)">
      <rect x="5" y="6" width="54" height="34" rx="10" fill="#FF5A4E" stroke="#1B1A2E" strokeWidth="4" />
      <path d="M20 23q12 10 24 0" stroke="#FFF8EC" strokeWidth="5" fill="none" strokeLinecap="round" />
      <circle cx="22" cy="16" r="3.2" fill="#FFC72C" />
      <circle cx="42" cy="16" r="3.2" fill="#FFC72C" />
    </g>
    <path d="M53 1l2.2 5.3 5.3 2.2-5.3 2.2L53 16l-2.2-5.3-5.3-2.2 5.3-2.2z" fill="#FFC72C" stroke="#1B1A2E" strokeWidth="2" strokeLinejoin="round" />
  </svg>
);

export const Logo = () => (
  <span className="flex items-center gap-2.5">
    <LogoMark />
    <span className="font-display font-semibold leading-[1.05] text-[15px] sm:text-base text-left">
      The Yard Party
      <br />
      Project
    </span>
  </span>
);
